import type Combatant from "@/encounter/model/Combatant.ts";

export function placeCombatantsAtArrival(combatants: Combatant[], levelId: string,
    arrival: {x: number; y: number}): Combatant[] {
    if (combatants.length === 0) return [];
    const center = {
        x: combatants.reduce((sum, combatant) => sum + combatant.position.x, 0) / combatants.length,
        y: combatants.reduce((sum, combatant) => sum + combatant.position.y, 0) / combatants.length,
    };
    return combatants.map(combatant => ({
        ...combatant,
        levelId,
        position: {
            x: arrival.x + combatant.position.x - center.x,
            y: arrival.y + combatant.position.y - center.y,
        },
    }));
}
